import React, { useEffect, useState } from 'react'
import Dialog from '../../GenericComponents/dialog'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
declare const window: any
const UnicornApp = window.unicornInstance as any

interface SendEmailAsPDFDialogProps {
    isOpen: boolean
    onClose: () => void
    WorkspaceId: string
}

const SendEmailAsPDFDialog: React.FC<SendEmailAsPDFDialogProps> = ({
    isOpen,
    onClose,
    WorkspaceId,
}) => {
    const [isEmailSent, setIsEmailSent] = useState(false)

    useEffect(() => {
        if (isOpen) {
            handleSendPDF()
        }
    }, [isOpen])

    const handleSendPDF = async () => {
        const wsid = String(WorkspaceId)
        try {
            const response = await fetch(`${window.baseURL}API/v3/Workspace/${wsid}/Email/pdf`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            if (!response.ok) {
                console.error('API error:', response.status, response.statusText)
                setIsEmailSent(true)
                return
            }
            setIsEmailSent(true)
        } catch (err) {
            console.error('Error during fetch:', err)
            FoundationsGenericToaster('error', 'Failed to send workspace as PDF. Please try again.')
            setIsEmailSent(false)
        }
    }

    return isOpen && isEmailSent ? (
        <Dialog
            isOpen={isOpen}
            title="Workspace as PDF"
            onClose={onClose}
            className="left-align-text"
            minHeight={100}
        >
            <div className="ajax-page-success">
                We are processing your request. Please check your
                <br />
                email inbox shortly.
            </div>
        </Dialog>
    ) : null
}

export default SendEmailAsPDFDialog
